module.exports = __webpack_public_path__ + "files/5a961ff91461a94df1c42381bd321ccd.png";